import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CompanyEditorForm } from "@/features/lead-gen/components/CompanyEditorForm";
import { LeadGenDetailShell } from "@/features/lead-gen/components/LeadGenDetailShell";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/companies/new")({
    component: AddCompanyPage,
});

function AddCompanyPage() {
    const { companies, leads, addCompany, renameCompany, setCompanyTeams, setCompanyUrl, setCompanyContexts } =
        useLeadGen();
    const navigate = useNavigate();

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Companies", route: { to: "/sales/leads/companies" } },
        { label: "Add company", route: { to: "/sales/leads/companies/new" } },
    ]);

    return (
        <LeadGenDetailShell backTo="/sales/leads/companies" backLabel="All companies">
            <CompanyEditorForm
                company={null}
                companies={companies}
                leads={leads}
                onCreate={(name, teams) => addCompany(name, teams)}
                onRename={renameCompany}
                onTeamsChange={setCompanyTeams}
                onUrlChange={setCompanyUrl}
                onContextsChange={setCompanyContexts}
                onCreated={(created) =>
                    void navigate({
                        to: "/sales/leads/companies/$companyId",
                        params: { companyId: created.company_id },
                        search: { briefing: undefined },
                        replace: true,
                    })
                }
            />
        </LeadGenDetailShell>
    );
}
